/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {shallowEqual, useSelector, useDispatch} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import {RootState} from '../../../../setup'
import {compareTwoObj, getInitials, IsRootUserOrAdmin, logoutPopup} from '../../../../app/services/Functional'
import CustomTooltip from '../../../tooltip/CustomTooltip'
import {KTSVG} from '../../../helpers'
import FAIcon from '../../../helpers/components/FAIcon'
import {faUserCircle, faUsers, faUserLock} from '@fortawesome/free-solid-svg-icons'
import BannerCard from '../../../../app/components/common/BannerCard'
import {setActiveTab} from '../../../../setup/redux/tabs/slices'

const HeaderUserMenu: FC = () => {
  const {user, active_inspection_company, isVisibleTCCcard, inspection_companies}: any = useSelector<RootState>(
    (state) => ({
      user: state.auth.user,
      active_inspection_company: state.auth.active_inspection_company,
      isVisibleTCCcard: state.auth.isVisibleTCCcard,
      inspection_companies: state.auth.inspection_companies,
    }),
    shallowEqual
  )

  const isSuperAdminUser = IsRootUserOrAdmin()
  const dispatch: Dispatch<any> = useDispatch()
  const navigate = useNavigate()
  const [isVisibleBuyHereLinkBtn, setIsVisibleBuyHereLinkBtn] = useState(true)

  useEffect(() => {
    if (isSuperAdminUser) {
      const isSameObj = compareTwoObj(inspection_companies[0], active_inspection_company)
      setIsVisibleBuyHereLinkBtn(isSameObj)
    }
  }, [active_inspection_company, inspection_companies])

  const logout = () => {
    logoutPopup(navigate)
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 list-menu profile-menu'
      data-kt-menu='true'
    >
      {user && (
        <div className='menu-item'>
          <div className='menu-content d-flex align-items-center flex-gap-10 p-0 mb-2'>
            <div className='symbol symbol-56px'>
              {user.avatar ? (
                <img alt='Logo' src={user.avatar} />
              ) : (
                <div className='symbol-label fs-3 bg-light-primary text-primary'>
                  {getInitials(user.name)}
                </div>
              )}
            </div>
            <div className='d-flex flex-column text-break'>
              <div className='cursor-default font-size-18 font-weight-SemiBold line-height-26 text-dark-indigo truncate-two-lines'>
                {user.name}
              </div>
              <div className='d-flex flex-column'>
                <CustomTooltip message={user.email} position='bottom' MenuallyPosition={true}>
                  <a className='cursor-pointer font-size-12 font-weight-regular line-height-22 text-lavender-gray truncate-one-line '>
                    {user.email}
                  </a>
                </CustomTooltip>
                <a className='cursor-default font-size-12 font-weight-regular text-lavender-gray user-role'>
                  Role:{' '}
                  {user.is_root
                    ? 'Decent Super-Admin'
                    : active_inspection_company?.groups?.length > 0
                      ? active_inspection_company.groups.map((group: any) => group.name).join(', ')
                      : '-'}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {isVisibleTCCcard && (
        <div className='menu-item'>
          <div className='menu-content p-2'>
            <BannerCard
              title={
                active_inspection_company?.slug === 'decent'
                  ? 'Your TCC Credit is low.'
                  : "Company's Decent Credit is Low."
              }
              variant='warning'
              className='mb-0'
              showLink={isVisibleBuyHereLinkBtn}
              linkText='Buy here'
              onLinkClick={() => {
                dispatch(setActiveTab({module: 'Orders', index: isSuperAdminUser ? 0 : 1}))
                navigate('/your-credits')
                setTimeout(() => {
                  const menuElement = document.querySelector('[data-kt-menu="true"]')
                  if (menuElement) {
                    const event = new MouseEvent('click', {
                      bubbles: true,
                      cancelable: true,
                      view: window,
                    })
                    document.body.dispatchEvent(event)
                  }
                }, 100)
              }}
            />
          </div>
        </div>
      )}

      <div className='separator my-3 mx-0' />

      <div className='d-flex flex-column gap-1'>
        <div className='menu-item p-0'>
          <Link
            to={'/profile/update'}
            className='menu-link p-2 font-size-14 font-weight-bold line-height-22 text-Steel-grayish-blue d-flex flex-gap-12'
          >
            <div className='badge badge-light-info fw-bolder'>
              <FAIcon
                icon={faUserCircle}
                className='text-success py-1 fs-2'
                defaultClassnameApply={false}
              />
            </div>
            My Profile
          </Link>
        </div>

        <div className='menu-item p-0'>
          <Link
            to={'/company/profile'}
            className='menu-link p-2 font-size-14 font-weight-bold line-height-22 text-Steel-grayish-blue d-flex flex-gap-12'
          >
            <div className='badge badge-light-info fw-bolder'>
              <FAIcon
                icon={faUsers}
                className='text-primary py-1 fs-6'
                defaultClassnameApply={false}
              />
            </div>
            My Company Profile
          </Link>
        </div>

        <div className='menu-item p-0'>
          <Link
            to={'/profile/change-password'}
            className='menu-link p-2 font-size-14 font-weight-bold line-height-22 text-Steel-grayish-blue d-flex flex-gap-12'
          >
            <div className='badge badge-light-info fw-bolder'>
              <FAIcon
                icon={faUserLock}
                className='text-warning py-1 fs-6'
                defaultClassnameApply={false}
              />
            </div>
            Change Password
          </Link>
        </div>
      </div>

      <div className='separator my-3 mx-0' />

      <div className='menu-item p-0'>
        <a
          onClick={logout}
          className='menu-link p-2 font-size-14 font-weight-bold line-height-22 text-Steel-grayish-blue d-flex flex-gap-12'
        >
          <div className='badge badge-light-info fw-bolder'>
            <KTSVG
              path='/media/icons/duotune/general/logout.svg'
              svgIconClassnameApply={false}
              className='m-0'
            />
          </div>
          Logout
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
